var validateContactUsForm = function () {
	var validateContactForm = new forms4i(),
	contactForm = document.getElementById("contactUsForm"),
	confirmationMsg = document.getElementById("confirmationMessage"),
	successMsg = document.getElementById("contactFrmConfirm"),
	errorMsg = document.getElementById("contactFrmError"),
	recaptchaErrorMsg = document.getElementById("contactFrmRecaptchaError"),
	recaptchaVerificationLink = document.getElementById("contactFrmRecaptchaLink"),
	loadingIcon = document.getElementById("loadingIcon"),

	omniture = (function () {		
	   	var  contactSuccess = function () {
	   		const account = typeof s_account === 'string' ? s_account : '4imprintprod';
			const s = typeof s_gi === 'function' ? s_gi(account) : '';
	    		if (s) {
	        		if(s.pageName) s.pageName = "Contact Form Confirmation";
	        		if(s.channel) s.channel = "Info Page";
	        		if(s.prop37) s.prop37 = "infopages/contactformconfirmation";
	        		s.t();
	       	 }
	   	 };
	
	    return {
	        ContactSuccess: contactSuccess
	    };
	}()),
	
	submitContactUs = async function() {	
		loadingIcon.classList.remove("hide");
		
		document.getElementById("btnContactUsSubmit").disabled = true;
		
		var recaptchaSiteKey = document.getElementsByClassName("recaptchaSiteKey")[0].value.toString();
		var recaptchaActionName = document.getElementsByClassName("recaptchaActionName")[0].value.toString();
		
		// Check if grecaptcha is defined
		// if not, try to fetch the script again 
		if(typeof grecaptcha == "undefined" && typeof get4iRecaptcha !== "undefined") await get4iRecaptcha();
		
		// need to show an error if recaptcha script still isn't available
		if(typeof grecaptcha == "undefined"){
			formError();
		}else{
			grecaptcha.execute(recaptchaSiteKey, { action: recaptchaActionName })
				.then(function(token) {
	
					var contactRequest = {
						Email: document.getElementById("Email").value,
						EmailBody: document.getElementById("EmailBody").value,
						RecaptchaActionName: recaptchaActionName,
						RecaptchaToken: token
					};
					var config = "";
					if(window.location.href.includes("outlet.4imprint.com")
					|| window.location.href.includes("outlet-sandbox.4imprint.com")
					|| window.location.href.includes("outletcore-dev.4imprint.com")
					|| window.location.href.includes("www.4imprint.")
					|| window.location.href.includes("sandboxmain.4imprint.")
					|| window.location.href.includes("localhost:7274/")){
						config = { 
							method: 'POST', 
							body: JSON.stringify(contactRequest), 
							headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": contactForm.querySelector("input[name='__RequestVerificationToken']").value } 
						};
					}else{
						var requestVerificationToken = contactForm.querySelector("input[name='__RequestVerificationToken']").value;
						if (requestVerificationToken == null) {
							requestVerificationToken = contactForm.getElementsByTagName('input')[0].getAttribute("value");
						}
						config = { 
							method: 'POST', 
							body: JSON.stringify(contactRequest), 
							headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": requestVerificationToken }
						};
					}
					fetch('/info/submitcontactus', config).then(function(response){
						return  (response.ok) ? response.json() : []; // response.json() returns a promise
					}).then(function(response){
						if (!response.modelStateInvalid) {
				   			confirmationMsg.classList.remove("hide");
							contactForm.classList.add("hide");
							if (!response.success) {
								if (response.recaptchaFailed) {
									recaptchaVerificationLink.setAttribute("href", response.recaptchaUrl);
									recaptchaErrorMsg.classList.remove("hide");
								}
								else {
									errorMsg.classList.remove("hide");
								}
								successMsg.classList.add("hide");
							}
							confirmationMsg.scrollIntoView({behavior: "smooth"});
							if (response.success) {
								omniture.ContactSuccess();
							}
						}
						else {
				    			var formHeading = document.getElementsByClassName("formHeading")[0];
							formHeading.insertAdjacentHTML('afterend', response.validationSummary);
				    			formHeading.scrollIntoView({behavior: "smooth"});
							loadingIcon.classList.add("hide");
						}
						document.getElementById("btnContactUsSubmit").disabled = false;
					}).catch(function(error){
						formError();
					});
				});
			}
	},
	
	formError = () => {
		confirmationMsg.classList.remove("hide");
		contactForm.classList.add("hide");
		errorMsg.classList.remove("hide");
		successMsg.classList.add("hide");
		confirmationMsg.scrollIntoView({behavior: "smooth"});
		document.getElementById("btnContactUsSubmit").disabled = false;
	},
	
	formSuccess = function() {
		submitContactUs();
    		confirmationMsg.scrollIntoView({behavior: "smooth"});
	},
	
	init = function() {
		if (document.getElementById("btnContactUsSubmit")) {
			document.getElementById("btnContactUsSubmit").addEventListener("click", function(e){
				e.preventDefault();
				validateContactForm.formValidation(contactForm, formSuccess, e);
			});
		} 
	};
	
	return {
		init: init
	};
	
};

(function() {
	var contactUsForm = new validateContactUsForm();
	contactUsForm.init();
})()